import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaMoneyBillWave,
  FaCheckCircle,
  FaBuilding,
  FaCalendarAlt,
  FaUserCheck,
  FaIdCard,
  FaFileAlt,
  FaExchangeAlt,
  FaClock,
  FaAppStore,
  FaCode,
  FaSpinner,
  FaExclamationCircle,
} from "react-icons/fa";
import { handleGetRequest } from "../../../services/GetTemplate";
import { Button } from "primereact/button";

const StyledIcon = styled.div`
  color: ${(props) => props.color};
`;

function AuthTransactionDetails({ fileHeadId }) {
  const [loading, setloading] = useState(false);
  const [fileStausDetailsData, setfileStausDetailsData] = useState([]);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const getFileStatus = async () => {
    setloading(true);
    const res = await handleGetRequest(
      "zbizgateway/authMatrixWorkFlow/authPendingRecordDetail/" + fileHeadId
    );
    setfileStausDetailsData(res?.data);
    setloading(false);
  };

  const statusBodyTemplate = (rowData) => {
    if (rowData?.statusCode === "I") {
      return (
        <StyledIcon color="orange">
          <FaSpinner /> In Progress
        </StyledIcon>
      );
    }
    if (rowData?.statusCode === "S") {
      return (
        <StyledIcon color="green">
          <FaCheckCircle /> Success
        </StyledIcon>
      );
    }
    if (rowData?.statusCode === "E") {
      return (
        <StyledIcon color="red">
          <FaExclamationCircle /> Error
        </StyledIcon>
      );
    }
  };

  useEffect(() => {
    if (fileHeadId !== null) {
      getFileStatus();
    }
  }, [fileHeadId]); // eslint-disable-line

  if (fileHeadId === null) {
    return null;
  }

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Define the columns to export and their new names
      const columnMapping = {
        employeeName: "Employee Number",
        employeeCnic: "Employee Cnic",
        employeeAccountNo: "Employee Account No",
        amount: "Amount",
        transactionCode: "Transaction Code",
        createdate: "Create Date",
        lastupdatedate: "Last Update Date",
        statusCode: "Status Code",
        statusDescr: "Status Description",
      };

      // Map the data to include only the specified columns with new names
      const exportData = fileStausDetailsData?.map((item) => {
        let obj = {};
        Object.keys(columnMapping).forEach((key) => {
          obj[columnMapping[key]] = item[key];
        });
        return obj;
      });

      // Convert the mapped data to a worksheet
      const worksheet = xlsx.utils.json_to_sheet(exportData && exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Save the Excel file
      saveAsExcelFile(excelBuffer, "File Status Summary");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
  };

  const transactionHeader = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <h4>Transaction Details</h4>
      <Button
        label="Export Excel"
        type="button"
        icon="pi pi-file-excel"
        onClick={exportExcel}
        className="p-button-success p-mr-2"
        data-pr-tooltip="XLS"
      />
    </div>
  );

  return (
    <div style={{ marginTop: "70px" }}>
      <div className="card">
        <DataTable
          header={transactionHeader}
          scrollable
          tableStyle={{ minWidth: "120rem" }}
          dataKey="fileDetailId"
          loading={loading}
          value={fileStausDetailsData}
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
        >
          <Column filter field="employeeName" header="Employee Name" />
          <Column filter field="employeeCnic" header="Employee CNIC" />
          <Column
            filter
            field="employeeAccountNo"
            header="Employee Account No"
          />
          <Column filter field="amount" header="Amount" />
          <Column filter field="transactionCode" header="Transaction Code" />
          <Column filter field="createdate" header="Create Date" />
          <Column filter field="lastupdatedate" header="Last Update Date" />
          <Column
            filter
            field="statusCode"
            body={statusBodyTemplate}
            header="Status Code"
          />
          <Column filter field="statusDescr" header="Status Description" />
        </DataTable>
      </div>
    </div>
  );
}

export default AuthTransactionDetails;
